import {
  GET_USERS,
  USER_LIST,
  USER_FILTERDETAIL,
  GETAUTHuserData,
  USER_DETAIL,
  ADD_USERS,
  EDIT_USER,
  USERSTATUS_UPDATE,
  USERS_ERROR,
  USER_PROFILE_UPDATE,
  USER_ROLE_AND_PARENT_CHANGE,
  GET_PARENT_USERLIST,
  USER_DETAILS_FOR_VISITOR
} from "../types";

const initialState = {
  userData: null,
  loading: true,
  create: false,
  detail: false,
  userDetails:null
};

export default function userDataStore(state = initialState, action) {
  switch (action.type) {
    case GET_USERS:
      return {
        ...state,
        create: false,
        detail: false,
        userData: action.payload,
      };
    case USER_LIST:
      return {
        ...state,
        create: false,
        detail: false,
        userData: action.payload,
      };
    case EDIT_USER:
      return {
        ...state,
        detail: false,
        create: true,
        userData: action.payload,
      };
    case USER_DETAIL:
      return {
        ...state,
        create: false,
        detail: true,
        userData: action.payload,
      };
    case USER_FILTERDETAIL:
      return {
        ...state,
        create: false,
        detail: false,
        userData: action.payload,
      };
    case ADD_USERS:
      return {
        ...state,
        create: true,
        detail: false,
        userData: action.payload,
      };
    case USERSTATUS_UPDATE:
      return {
        ...state,
        create: true,
        detail: false,
        userData: action.payload,
      };
    case USER_ROLE_AND_PARENT_CHANGE:
      return {
        ...state,
        create: false,
        detail: false,
        roleChange: action.payload,
      };

    case USERS_ERROR:
      return {
        ...state,
        detail: true,
        create: true,
        response: action.payload,
      };

    case GET_PARENT_USERLIST:
      return {
        ...state,
        create: false,
        detail: false,
        parentUsers: action.payload,
      };
    case USER_DETAILS_FOR_VISITOR:
      return {
        ...state,
        create: false,
        detail: true,
        userDetails: action.payload,
      };
    default:
      return state;
  }
}
